import { twMerge } from "tailwind-merge";

export function Heading1({
  children,
  elementType,
  className,
  id,
}: {
  children: React.ReactNode;
  elementType: "h1" | "p";
  className?: string;
  id?: string;
}) {
  const Element = elementType;

  return (
    <Element
      id={id}
      className={twMerge(
        "text-4xl font-extrabold tracking-tight text-gray-900 lg:text-5xl",
        className
      )}
    >
      {children}
    </Element>
  );
}
